import { createGlobalStyle } from 'styled-components';

// Polyfill :focus-visible
import 'focus-visible';

const GlobalStyle = createGlobalStyle`
  .js-focus-visible :focus:not([data-focus-visible-added]) {
    outline: none;
  }

  div.sentry-error-embed-wrapper {
    // Before it was using ${({ theme }) => theme.zIndices.modal};
    // but it was breaking the render of storybook as theme is not available
    // in this context. This number is the same as the one in the theme.
    z-index: 1060;
  }
`;

export default GlobalStyle;
